function StickerPlayground(stickers, container, options) {
  this.stickers = stickers
  this.container = container
  this.options = options || {}
  this.enabled = false
  this.stickerEq = -1

  this.minViewport = this.options.minViewport || 480
  this.ignoredElements = this.options.ignoredElements || []

  this.onClick = this.onClick.bind(this)
}

StickerPlayground.prototype.init = function () {
  this.prepareTheScene()

  var self = this

  var currentWidth = window.innerWidth

  if (currentWidth >= this.minViewport) {
    this.enable()
  }

  window.addEventListener('resize', handleResize)

  function handleResize() {
    if (currentWidth === window.innerWidth) {
      return
    }

    if (window.innerWidth >= self.minViewport) {
      self.enable()
    } else {
      self.disable()
    }

    currentWidth = window.innerWidth
  }
}

StickerPlayground.prototype.disable = function () {
  if (this.enabled) {
    this.container.removeEventListener('click', this.onClick)
    this.enabled = false
  }
}

StickerPlayground.prototype.enable = function () {
  if (!this.enabled) {
    this.container.addEventListener('click', this.onClick)
    this.enabled = true
  }
}

StickerPlayground.prototype.onClick = function (e) {
  var ignoreClick = false

  this.ignoredElements.forEach(function (el) {
    if (el === e.target || el.contains(e.target)) {
      ignoreClick = true
    }
  })

  if (ignoreClick) {
    return
  }

  var options = this.options
  var container = this.container

  var stickerSelector = '.stickers-pool > .stickers-playground-sticker'
  var stickersCollection = container.querySelectorAll(stickerSelector)

  var lastEq = stickersCollection.length - 1

  if (this.stickerEq === lastEq) {
    this.stickerEq = 0
  } else {
    this.stickerEq++
  }

  var poolImage = stickersCollection.item(this.stickerEq)

  var clonedSticker = poolImage.cloneNode()
  clonedSticker.style.visibility = 'hidden'

  var rotateRatio = genRandomNumber(-60, 60, 0)
  var transformRotate = 'rotate(' + rotateRatio + 'deg)'

  clonedSticker.style.transform = 'scale(0.3, 0.3) ' + transformRotate

  var containerRect = container.getBoundingClientRect()

  clonedSticker.addEventListener('load', function () {
    var posX =
      ((e.pageX - containerRect.left + window.pageXOffset - clonedSticker.offsetWidth / 2) /
        containerRect.width) *
      100
    var posY =
      ((e.pageY - (containerRect.top + window.pageYOffset) - clonedSticker.offsetHeight / 2) /
        containerRect.height) *
      100

    var scaleRatio = genRandomNumber(0.6, 1.2, 2)

    clonedSticker.style.left = posX.toFixed(2) + '%'
    clonedSticker.style.top = posY.toFixed(2) + '%'
    clonedSticker.style.transform =
      'scale(' + scaleRatio + ',' + scaleRatio + ') ' + transformRotate
    clonedSticker.style.transition = 'transform 200ms ease'

    clonedSticker.style.visibility = 'visible'
  })

  container.appendChild(clonedSticker)

  setTimeout(function () {
    clonedSticker.style.transform = 'scale(0, 0) ' + transformRotate
  }, options.timeout || 2000)
}

StickerPlayground.prototype.prepareTheScene = function () {
  var stickersPool = document.createElement('div')
  stickersPool.classList.add('stickers-pool')

  var stickersFragment = document.createDocumentFragment()

  this.stickers.forEach(function (src, idx) {
    var image = document.createElement('img')

    image.alt = ''
    image.src = src
    image.classList.add(
      'lazyload',
      'stickers-playground-sticker',
      'stickers-playground-sticker--' + (idx + 1),
    )

    stickersFragment.appendChild(image)
  })

  stickersPool.appendChild(stickersFragment)

  this.container.appendChild(stickersPool)
  this.container.style.cursor =
    'url(https://static-website.miro.com/static/images/sticker-playground/cursor.svg), auto'
}

function genRandomNumber(min, max, decimalPlaces) {
  var rand = Math.random() * (max - min) + min
  var power = Math.pow(10, decimalPlaces || 0)

  return Math.floor(rand * power) / power
}

export default StickerPlayground
